import { render } from "./AnagraficaCrud.vue?vue&type=template&id=6c36cb17"
import script from "./AnagraficaCrud.vue?vue&type=script&lang=js"
export * from "./AnagraficaCrud.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__